var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.7782 7.29289C15.1688 7.68342 15.1688 8.31658 14.7782 8.70711L8.70718 14.7782C8.07721 15.4081 7.00007 14.962 7.00007 14.0711L7.00007 1.92893C7.00007 1.03803 8.07721 0.591861 8.70718 1.22183L14.7782 7.29289Z","fill":"#C4006B"}));
}

Play.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Play;

Play.default = Play;
